import {DocumentExchangeDto} from "../document-exchange.dto";
import {isDefined} from "../../../libs/utils/epic.utils";

export class InvoiceExchangePositionDto {

  public readonly id!: string;
  public readonly sellingPriceNet!: number;
  public readonly netAmount!: number;
  public readonly grossAmount!: number;
  public readonly vatAmount!: number;
  public readonly totalNetAmount!: number;
  public readonly totalGrossAmount!: number;
  public readonly totalVatAmount!: number;
  public readonly netAmountWithoutDiscount!: number;
  public readonly totalNetAmountWithoutDiscount!: number;
  public readonly totalGrossAmountWithoutDiscount!: number;
  public readonly totalVatAmountWithoutDiscount!: number;
  public readonly discountValue!: number;
  public readonly discountNetAmount!: number;
  public readonly discountGrossAmount!: number;
  public readonly discountTotalNetAmount!: number;
  public readonly discountTotalGrossAmount!: number;
  public readonly exchangeText!: string;
  public readonly exchange!: DocumentExchangeDto;

  constructor(init?: Partial<InvoiceExchangePositionDto> | undefined) {
    Object.assign(this, init);
    if (isDefined(init?.exchange)) {
      this.exchange = new DocumentExchangeDto(init.exchange);
    }
  }
}
